import React, { ComponentType } from "react";
import { Typography } from "@episerver/ui-framework";

interface ExternalImageProps {
    src: string;
    alt?: string;
}

export const ExternalImage: ComponentType<ExternalImageProps> = ({
    src,
    alt
}) => {
    if (alt) {
        return (
            <figure>
                <img src={src} alt={alt} />
                <Typography use="caption" tag="figcaption">{alt}</Typography>
            </figure>
        );
    }
    return <img src={src} />;
};
